export default "__VITE_ASSET__CepytG7O__"